<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
      <mat-card-title>
        <div class="w-100 d-flex" style="background: #0f172a;">
          <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Connecter une imprimante bluetooth" | translate }} </span>
          <button class="m-l-auto" mat-icon-button (click)="dismiss()">
            <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
          </button>
        </div>
      </mat-card-title>
      <mat-card-subtitle style="background: #dee8ff;color: black;" class="p-t-16 p-b-16">
        <div class="d-flex">
          <div class="d-flex flex">
            <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
              <button mat-icon-button>
                <i-tabler name="artboard-off" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
              </button>
            </div>
            <div class="d-grid">
              <span class="f-w-700"> 
                {{ "Connecter une imprimante bluetooth" | translate }}
              </span>
              <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">{{ "Périphériques Bluetooth" | translate }}</span>
            </div>
          </div>
          <div class="m-l-auto">
          </div>
        </div>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 0;">
      <div style="display: flex; flex-direction: column; flex: 1; overflow-y: scroll; max-height: 350px;">
          <div class="alert alert-danger" *ngIf="!!errMessage" role="alert" style="margin-top: 10px">
              {{ errMessage }}
          </div>
          <ng-container *ngIf="btDevicesScanned.length == 0 && !errMessage">
            <div style="width: 100; display: flex; justify-content: center; align-items: center">
              <mat-spinner></mat-spinner>
            </div>
          </ng-container>
          <ng-container *ngFor="let device of btDevicesScanned">
              <div style="display: flex; flex-direction: row; gap: 10px; padding: 10px;">
                  <div>
                      <mat-icon style="font-size: 36px;color: #AAA;">bluetooth</mat-icon>
                  </div>
                  <div style="flex: 1; display: flex; flex-direction: column">
                      <div>{{ device.NAME }}</div>
                      <div>{{ device.MAC_ADDRESS }}</div>
                  </div>
                  <div>
                      <button mat-flat-button color="primary" [disabled]="loading" (click)="doConnectToBTDevice(device)" *ngIf="!btDeviceConnected">Connecter</button>
                      <button mat-flat-button color="accent" [disabled]="loading" (click)="doDisconnectBTDevice()" *ngIf="!!btDeviceConnected && btDeviceConnected.MAC_ADDRESS == device.MAC_ADDRESS">Se deconnecter</button>
                  </div>
              </div>
              <mat-divider></mat-divider>
          </ng-container>
      </div>
    </mat-card-content>
    <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #5d87ff;">
      <div class="d-flex w-100" style="padding-top: 6px;">
        <button 
            mat-stroked-button 
            (click)="dismiss()"
            style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;" 
            [disabled]="loading">
          {{ "FERMER" | translate }}
        </button>
      </div>
    </mat-card-actions>
  </mat-card>